import { useMemo } from 'react';
import { useCommonTranslation } from 'c-translation';
import { CAMPAIGN_TYPES, campaignTypeLabel } from 'c-main/Lib/Campaign/campaignTypes';

/** The campaign type select's options, translated, for the create and edit forms. */
const useCampaignTypeOptions = () => {
    const t = useCommonTranslation();
    return useMemo(
        () => CAMPAIGN_TYPES.map(type => ({ label: t(campaignTypeLabel(type)), value: type })),
        [t],
    );
};

export default useCampaignTypeOptions;
